module.exports = __webpack_public_path__ + "media/images/page/step_img03-b362aa9a317cbfef734afee1315f931e.svg";